import { reviews, type Review } from "@/mocks/reviews";

export default function ReviewSection() {
  const columns: Review[][] = [[], [], []];
  reviews.forEach((review, i) => {
    columns[i % 3].push(review);
  });

  return (
    <section className="py-16 md:py-24 bg-background-100" aria-labelledby="reviews-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Buyer Reviews
          </span>
          <h2 id="reviews-heading" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Real Buyers.<br />Real Reviews.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {columns.map((col, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-5 md:gap-6">
              {col.map((review) => (
                <div
                  key={review.username}
                  className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/40"
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full ${review.avatarBg} flex items-center justify-center flex-shrink-0`}>
                      <span className="text-sm font-semibold text-foreground-700">{review.avatarText}</span>
                    </div>
                    <div>
                      <p className="font-semibold text-foreground-900 text-sm">{review.name}</p>
                      <p className="text-foreground-400 text-xs">{review.username}</p>
                    </div>
                  </div>
                  <div className="mt-4 flex gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-amber-400 text-xs"></i>
                    ))}
                  </div>
                  <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
                    &ldquo;{review.text}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}